import { RefObject, useEffect } from 'react';
import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { useCurrentDialogMember } from './useCurrentDialogMember';
import { useCurrentUserContext } from './user.ctx';
import { useMarkMessageAsRead } from './useMarkMessageAsRead';

export const useReadNotification = (ref: RefObject<HTMLElement | null>, message: DialogMessageViewModel, disableReading?: boolean) => {
  const { id: messageId, dialogId, deliveries } = message;
  const provider = useCurrentUserContext();
  const currentMember = useCurrentDialogMember();
  const markMessageAsRead = useMarkMessageAsRead(dialogId, messageId);
  const myDelivery = deliveries.find((delivery) => delivery.recipientId === currentMember?.id);

  useEffect(() => {
    const element = ref.current;
    if (!element || !myDelivery || myDelivery.isRead) {
      return;
    }
    const observer = new IntersectionObserver(async ([entry], observerInstance) => {
      if (!entry.isIntersecting || disableReading) {
        return;
      }
      observerInstance.unobserve(entry.target);
      await markMessageAsRead(provider.getUser());
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [myDelivery, messageId, dialogId, ref, disableReading, provider, markMessageAsRead]);
};
